function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "clock",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "face",
    style: {
      animationIterationCount: "infinite",
      animationTimingFunction: "linear",
      transformOrigin: "50% 50%",
      animationDuration: "18s",
      animationDirection: "normal"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    className: "circle",
    cx: 300,
    cy: 300,
    r: 253.9,
    style: {
      fill: "#fff",
      stroke: "rgba(255, 255, 255, 0.4)",
      strokewidth: 80,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "hour-marks",
    d: "M300.5 94V61M506 300.5h32M300.5 506v33M94 300.5H60M411.3 107.8l7.9-13.8M493 190.2l13-7.4M492.1 411.4l16.5 9.5M411 492.3l8.9 15.3M189 492.3l-9.2 15.9M107.7 411L93 419.5M107.5 189.3l-17.1-9.9M188.1 108.2l-9-15.6",
    style: {
      fill: "none",
      stroke: "#52526c",
      strokewidth: 9,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "mid-circle",
    cx: 300,
    cy: 300,
    r: 16.2,
    style: {
      fill: "#000"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "hour",
    style: {
      transformOrigin: "300px 300px",
      transition: "transform 0.5s ease-in-out"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "hour-hand",
    d: "M300.5 298V142",
    style: {
      fill: "none",
      stroke: "#ff7e00",
      strokewidth: 17,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "sizing-box",
    cx: 300,
    cy: 300,
    r: 253.9,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "minute",
    style: {
      transformOrigin: "300px 300px",
      transition: "transform 0.5s ease-in-out"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "minute-hand",
    d: "M300.5 298V67",
    style: {
      fill: "none",
      stroke: "#ff7e00",
      strokewidth: 11,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "sizing-box",
    cx: 300,
    cy: 300,
    r: 253.9,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "second",
    style: {
      transformOrigin: "300px 300px",
      transition: "transform 0.5s ease-in-out"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "second-hand",
    d: "M300.5 350V55",
    style: {
      fill: "none",
      stroke: "#ffaa05",
      strokewidth: 15,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "sizing-box",
    cx: 300,
    cy: 300,
    r: 253.9,
    style: {
      fill: "none"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.d574fab791ca459eb40df8ea45ee946a.svg";
export { ForwardRef as ReactComponent };